import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import UprezShareFormField from '../../../../components/Share/UprezForm/Field';
import { FormField } from '../../../../components/Share/UprezForm/typings';

interface UprezShareFormFieldStateProps {
	fieldName: FormField;
}

const mapStateToProps = (state: StoreState, props: UprezShareFormFieldStateProps) => {
	const { sharePanel } = state;
	const { form, isOpen, crmContacts } = sharePanel;
	const { fieldName } = props;
	return { fieldValue: form[fieldName], isOpen, crmContacts };
};

export default connect(mapStateToProps)(UprezShareFormField);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/UprezForm/Field/index.tsx